import React from "react";
import "./Chips.css";

/* status is optional and defaults to "active" — this page's allocation
   rows don't carry a user active/unavailable flag today, but the
   component supports it so other pages can pass one in later without
   any change here. */
const STATUS_FAMILY = {
  active: "chip-indigo",
  inactive: "chip-neutral",
  unavailable: "chip-warning",
};

export default function UserChip({ name, status = "active" }) {
  const label = name || "-";
  const family = STATUS_FAMILY[status] || STATUS_FAMILY.active;

  return (
    <span className={`chip ${family}`} title={label}>
      <i className="fa-solid fa-user" aria-hidden="true"></i>
      <span className="chip-label">{label}</span>
    </span>
  );
}
